module.exports = __webpack_public_path__ + "img/habeinleumi.534c0339.svg";